import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getSelectedPoolDataList } from '../../../../../services/api';
import Observer from '@researchgate/react-intersection-observer';
import styles from './index.css';
import Module from '../../module';

class Tech extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        dataListArr: [],
    };

    async getDataListFn() {
        try {
            const dataListArr = await getSelectedPoolDataList('20002');

            this.setState({
                dataListArr,
            });
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (event, unobserve) => {
        const { content } = this.props;
        const { isAsync } = content;

        if (event.isIntersecting) {
            unobserve();
            if (isAsync) {
                this.getDataListFn();
            }
        }
    };

    render() {
        const { content } = this.props;
        const { dataListArr } = this.state;
        const { techMd, techSlide, techFeed, techAd, isAsync } = content;

        const normalTabsData = techMd;
        const viewMoreLinkData = (techMd && techMd.moreTh) || '';
        const newsStreamData = isAsync ? dataListArr : techFeed;
        const mdBannerData = techSlide;

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '50171',
                type: 'struct',
                title: '科技子导航数据',
                groupName: 'content',
                translate: 'handleHomeTechMdInfo',
            };
        }
        if (mdBannerData) {
            mdBannerData.chipConfig = {
                id: '75192',
                type: 'recommend',
                title: '科技焦点图数据',
                groupName: 'content',
                translate: 'handleHomeTechSlideInfo',
            };
        }
        const moduleData = {
            normalTabsData,
            feedAd: techAd,
            mdBannerData,
            newsStreamData,
            viewMoreLinkData,
        };

        return (
            <Observer onChange={this.handleChange}>
                <section className={styles.tech}>
                    <Module content={moduleData} />
                </section>
            </Observer>
        );
    }
}

export default errorBoundary(Tech);
